import { Dispatch, FC, SetStateAction } from 'react';
import { MenuConfig, Sidebar, Spinner } from 'alurkerja-ui';
import { useLocation } from 'react-router-dom';
import { UserService } from '@/api/user';
import { useGetMenu } from '@/utils/configs/menu';

interface MenuWrapperProps {
  children: JSX.Element;
  menu: MenuConfig;
}

interface ExtendedSidebarProps {
  toggled: boolean;
  setToggled: Dispatch<SetStateAction<boolean>>;
  menuWrapper: (props: MenuWrapperProps) => JSX.Element;
}

export const ExtendedSidebar: FC<ExtendedSidebarProps> = ({ setToggled, toggled, menuWrapper }) => {
  const { data } = UserService.useGetProfile();
  const { pathname } = useLocation();
  const { filteredMenu: menu, isLoadingBusinessProcesses: isLoading } = useGetMenu({ role: data?.role });

  return (
    <div className="fixed z-20 sidebar-ciomy">
      <Sidebar
        logo={
          isLoading ? (
            <div data-testid="spinner">
              <Spinner className="text-white" />
            </div>
          ) : (
            <div className="flex items-center justify-center p-12" data-testid="logo">
              <img src="/logo_ciomy.png" alt="Ciomy Logo" />
            </div>
          )
        }
        toggled={toggled}
        setToggled={setToggled}
        menuConfig={menu}
        currentPathName={pathname}
        menuWrapper={menuWrapper}
      />
    </div>
  );
};
